"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const utils_1 = require("./utils");
/* eslint-disable */
exports.default = () => {
    let metadata;
    if (typeof window !== "undefined" &&
        window.__TVG_GLOBALS__ &&
        window.__TVG_GLOBALS__.METADATA) {
        const data = (0, utils_1.attempt)(() => JSON.parse(decodeURIComponent(window.__TVG_GLOBALS__.METADATA || "")));
        if (!(data instanceof Error)) {
            metadata = data;
        }
    }
    return metadata || false;
};
/* eslint-enable */



// WEBPACK FOOTER //
// ./node_modules/@tvg/conf/cjs/src/metadata.js